import { default as FooterActions } from './FooterActions.vue'
import { default as FooterContent } from './FooterContent.vue'
import { default as FooterRoot, type DialogFooterProps } from './FooterRoot.vue'
import { default as Root, type DialogRootProps } from './Root.vue'

export const Dialog = {
  Root,
  Footer: {
    Root: FooterRoot,
    Actions: FooterActions,
    Content: FooterContent
  }
} as {
  Root: typeof Root
  Footer: {
    Root: typeof FooterRoot
    Actions: typeof FooterActions
    Content: typeof FooterContent
  }
}

export { type DialogFooterProps, type DialogRootProps }
